/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

// ---------- Service Catalog ----------
export async function listServiceTemplates() {
  const res = await api.get('/services/templates');
  return res.data; // {role, templates}
}
export async function listMyServices() {
  const res = await api.get('/services/mine');
  return res.data;
}
export async function createService(payload) {
  const res = await api.post('/services', payload);
  return res.data.service;
}
export async function updateService(id, payload) {
  const res = await api.patch(`/services/${id}`, payload);
  return res.data.service;
}
export async function deleteService(id) {
  const res = await api.delete(`/services/${id}`);
  return res.data;
}
export async function listProfessionalServices(professionalId) {
  const res = await api.get(`/services/professional/${professionalId}`);
  return res.data;
}
export async function searchServices({ role, category, max_price, limit = 50 } = {}) {
  const res = await api.get('/services/search', { params: { role, category, max_price, limit } });
  return res.data;
}

// ---------- Wound Care ----------
export async function createWoundCase({ body_region, wound_type_declared, context, image_base64, mime_type }) {
  const res = await api.post('/wound-care/case', { body_region, wound_type_declared, context, image_base64, mime_type });
  return res.data.case;
}
export async function listWoundCases() {
  const res = await api.get('/wound-care/cases');
  return res.data;
}
export async function getWoundCase(id) {
  const res = await api.get(`/wound-care/case/${id}`);
  return res.data.case;
}
export async function addWoundPhoto(id, { image_base64, mime_type, note }) {
  const res = await api.post(`/wound-care/case/${id}/photo`, { image_base64, mime_type, note });
  return res.data.photo;
}
export async function analyzeWoundCase(id) {
  const res = await api.post(`/wound-care/case/${id}/analyze`);
  return res.data.analysis;
}
export async function addWoundNote(id, text) {
  const res = await api.post(`/wound-care/case/${id}/note`, { text });
  return res.data.note;
}
export async function closeWoundCase(id) {
  const res = await api.post(`/wound-care/case/${id}/close`);
  return res.data;
}
export async function assignWoundNurse(id, nurse_id) {
  const res = await api.post(`/wound-care/case/${id}/assign`, { nurse_id });
  return res.data;
}

// ---------- Care Team ----------
export async function createCareTeam({ label, description } = {}) {
  const res = await api.post('/care-team/create', { label, description });
  return res.data;
}
export async function listMyCareTeams() {
  const res = await api.get('/care-team/mine');
  return res.data;
}
export async function inviteCareMember(teamId, user_id, role_note) {
  const res = await api.post(`/care-team/${teamId}/invite`, { user_id, role_note });
  return res.data;
}
export async function removeCareMember(teamId, userId) {
  const res = await api.delete(`/care-team/${teamId}/member/${userId}`);
  return res.data;
}
export async function addCareNote(teamId, { text, mentions, kind = 'note' }) {
  const res = await api.post(`/care-team/${teamId}/note`, { text, mentions, kind });
  return res.data.note;
}
export async function getCareTimeline(teamId) {
  const res = await api.get(`/care-team/${teamId}/timeline`);
  return res.data;
}
